import { fetchWithBodyTemplateFn } from './base/fetch-with-body-template-fn';

export const createTemplateFn = fetchWithBodyTemplateFn('POST');
